import React, {Component, Fragment} from 'react';
import CanvasContext from './CanvasContext'

import {
  Link,
} from 'react-router-dom';

/*tutaj w konstruktorze trzeba dac dwa parametry:
1. gdzie isc po wcisnieciu cofnij
2. funkcja: upload czy edit
No i trzeba z inna sciezka w link to*/ 
class HeaderForm1 extends Component {
    constructor(props) {
      super(props);
      if(props.project == null)
      {
        this.state = {
          name: "",
          surname : "",
          age: ""
        };  
      }
      else
      {
        this.state = {
          name: props.project.name,
          surname : props.project.surname,
          age: props.project.age
        }; 
      }
      this.index = props.index;
      this.handleInputChange = this.handleInputChange.bind(this);
      this.documentID = props.documentID;
    }
  
    handleInputChange(event) {
      const target = event.target;
      const value = target.value;
      const name = target.name;
  
      this.setState({
        [name]: value
      });
    }

    onClickFoo(context)
    {
      if(this.props.project == null)
      {
        context.AddNewElementToRawData("header", this.state.name, this.state.surname, this.state.age)
      }
      else
      {
        context.editElement(this.index, "header", this.state.name, this.state.surname, this.state.age)
      }

    }
    render() {
      return (
        <div class="flex-fill flex-column align-items-start justify-content-center">
        <CanvasContext.Consumer>
          {(context) =>
          context.Navbar(`/dashboard/${this.documentID}/addheader`)      
          }
           </CanvasContext.Consumer>
        <form>
          <div class="input-group mb-3">
            <input
              class="form-control" 
              placeholder="name"
              name="name"
              type="text"
              value={this.state.name}
              onChange={this.handleInputChange} />
          </div>

            <div class="input-group mb-3">
            <input
              class="form-control" 
              placeholder="surname"
              name="surname"
              type="text"
              value={this.state.surname}
              onChange={this.handleInputChange} />
          </div>

            <div class="input-group mb-3">
            <input
              class="form-control" 
              placeholder="age"
              name="age"
              type="text"
              value={this.state.age}
              onChange={this.handleInputChange} />
            </div>
            <Link to={`/dashboard/${this.documentID}/addheader`}>
            <button type="button" class="btn btn-outline-secondary btn-lg">Return</button>
            </Link>
          <CanvasContext.Consumer>
          {(context) =>
                <button type="button" class="btn btn-outline-success btn-lg" 
                 onClick={() => this.onClickFoo(context)} >Generate</button>                
          }
           </CanvasContext.Consumer>
        </form>
        </div>
      );
    }
  }

  export default HeaderForm1